export default [
  {
    path: '/skillTrain',
    // redirect: '/skillTrain/teacherTraining',
    component: () => import('@/views/skill-train/index.vue'),
    children: [
      {
        path: 'teacherTraining',
        name: 'teacherTraining',
        component: () => import('@/views/skill-train/teacher-training/index.vue'),
        meta: {
          title: '师资培训',
        },
      },
      {
        path: 'researchTraining',
        name: 'researchTraining',
        component: () => import('@/views/skill-train/research-training/index.vue'),
        meta: {
          title: '考证培训',
        },
      },
      {
        path: 'specialTraining',
        name: 'specialTraining',
        component: () => import('@/views/skill-train/special-training/index.vue'),
        meta: {
          title: '专项培训',
        },
      },
      {
        path: 'highTraining',
        name: 'highTraining',
        component: () => import('@/views/skill-train/high-training/index.vue'),
        meta: {
          title: '高端培训',
        },
      },
    ],
  },
];

